<template>
  <article>
    <p class="has-text-weight-semibold has-text-grey-dark is-size-5">
      {{ title }}
      <span v-if="required" class="has-text-danger">*</span>
    </p>
    <p class="mt has-text-weight-light has-text-grey is-size-7 -mt"><slot/></p>
  </article>
</template>

<script>
export default {

  props: {
    required: Boolean,
    title: String,
  }

}
</script>
